import { History } from 'history'

export function redirectIfEntityNotFound<T>(entity: T | null | undefined, fallbackPath: string, history: History): entity is T {
  if (entity === null || entity === undefined) {
    history.push(fallbackPath)
    return false
  }
  return true
}
